import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  searchBar: {
    padding: '20px 24px',
    boxShadow: palette.shadows.light,
    background: palette.gradients.white,
    display: 'flex',
    marginTop: '32px',
    borderRadius: '2px',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexWrap: 'wrap'
    }
  },
  searchField: {
    flexGrow: '1',
    marginRight: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%',
      marginRight: '0',
      marginBottom: '20px'
    }
  },
  filterSelector: {
    width: '240px',
    '& + &': {
      marginLeft: '10px'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      width: 'initial',
      flex: '1 1 0'
    }
  },
  chargesRangeDatePicker: {
    marginLeft: '10px',
    width: '130px'
  }
});
export default useStyles;